var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrappedCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.5V7.5C2 4.5 4 2.5 7 2.5H17C20 2.5 22 4.5 22 7.5V9.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.5V17.5C2 20.5 4 22.5 7 22.5H17C20 22.5 22 20.5 22 17.5V15.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69995 9.76001L12 12.83L17.2599 9.78003",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.2701V12.8201",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.76 6.79006L7.55998 8.57009C6.83998 8.97009 6.23999 9.98008 6.23999 10.8101V14.2001C6.23999 15.0301 6.82998 16.0401 7.55998 16.4401L10.76 18.2201C11.44 18.6001 12.56 18.6001 13.25 18.2201L16.45 16.4401C17.17 16.0401 17.77 15.0301 17.77 14.2001V10.8101C17.77 9.98008 17.18 8.97009 16.45 8.57009L13.25 6.79006C12.56 6.40006 11.44 6.40006 10.76 6.79006Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrappedCube);
export default __webpack_public_path__ + "static/media/wrapped-cube.036e350aaae215f1bc1967ba39b339c5.svg";
export { ForwardRef as ReactComponent };